import { Footer } from "@excalidraw/excalidraw/index";
import React from "react";

import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

import { isExcalidrawPlusSignedUser } from "../app_constants";

import { DebugFooter, isVisualDebuggerEnabled } from "./DebugCanvas";
import { EncryptedIcon } from "./EncryptedIcon";
import { ExcalidrawPlusAppLink } from "./ExcalidrawPlusAppLink";
import FooterUi from "./fileUpload/features/paging_docment/footerUi";

export const AppFooter = React.memo(
  ({
    onChange,
    excalidrawApi,
  }: {
    onChange: () => void;
    excalidrawApi: ExcalidrawImperativeAPI | null;
  }) => {
    return <Footer>{excalidrawApi && <FooterUi />}</Footer>;
  },
);
